import React, { Component } from 'react';
import autosize from 'autosize';
import classnames from 'classnames';
import { Field } from 'redux-form';

export default class Textarea extends Component {
  constructor(props) {
    super(props);
    this.fieldInput = this.setupInput(props);
  }

  setupInput(props) {
    return ({ input, meta, placeholder, ...attrs }) => {
      let sign;
      let placeholderText = '';
      if (props.prefix) {
        sign = <div className="c-prefix">{props.prefix}</div>;
      }
      let validationError = null;
      if (meta && meta.touched && meta.error) {
        validationError = (<div className="c-input-error-message">{meta.error}</div>);
      }

      if (placeholder && !input.value) {
        placeholderText = placeholder;
      }

      return (
        <div className="u-position-relative">
          { sign }
          <textarea
            rows="1"
            {...input}
            {...attrs}
            className={classnames(attrs.className, { 'c-input--prepend': attrs.prefix })}
            placeholder={placeholderText}
            ref={(el) => { this._textarea = el; }}
          />
          {validationError}
        </div>
      );
    };
  }

  componentDidMount() {
    autosize(this._textarea);
  }

  render() {
    const { name, prefix, datepicker, ...attributes } = this.props;
    if (!name) return null;

    return (<Field name={name} component={this.fieldInput} {...attributes} />);
  }
}
